var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("打字机效果")]),_c('div',{staticClass:"output"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.displayedText)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }